<header>
	<div class="topbar d-flex align-items-center">
		<nav class="navbar navbar-expand">
			<div class="mobile-toggle-menu"><i (click)="toggleSidebar()" class='bx bx-menu'></i>
			</div>
			<div class="top-menu ms-auto">
				<ul class="navbar-nav align-items-center">

				</ul>
			</div>
			<div class="user-box dropdown">
				<a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
					<div class="user-info ps-3">
						<p class="user-name mb-0">{{companyName$ | async}}</p>
						<p class="designattion mb-0">{{companyLocation$ | async}}</p>
					</div>
				</a>
				<ul class="dropdown-menu dropdown-menu-end">
					<li *forRoles="['ACTIVE_MEMBER' || 'INACTIVE_MEMBER']"><a class="dropdown-item" routerLink="/profile"><i class="bx bx-user"></i><span>Profile</span></a>
					</li>
					<li *forRoles="['INACTIVE_MEMBER']"><a class="dropdown-item" routerLink="/profile"><i class="bx bx-user"></i><span>Profile</span></a>
					</li>
					<li><a class="dropdown-item" routerLink="/dashboard/member-dashboard"><i class='bx bx-home-circle'></i><span>Dashboard</span></a>
					</li>
					<li>
						<div class="dropdown-divider mb-0"></div>
					</li>
					<li><a class="dropdown-item" (click)="logout()"><i class='bx bx-log-out-circle'></i><span>Logout</span></a>
					</li>
				</ul>
			</div>
		</nav>
	</div>
</header>
